import React from 'react';

/**
 * Error Boundary: evita tela em branco quando um erro ocorre na árvore.
 * Mostra fallback com opção de recarregar.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            fontFamily: 'system-ui, sans-serif',
            backgroundColor: '#f8f9fa',
            color: '#1a1a1a',
          }}
        >
          <h1 style={{ fontSize: '1.5rem', marginBottom: 8 }}>Ops! Ocorreu um erro</h1>
          <p style={{ color: '#666', marginBottom: 10, textAlign: 'center', maxWidth: 440 }}>
            Não foi possível carregar esta tela. Isso pode acontecer por instabilidade temporária ou
            falha de conexão.
          </p>
          <p style={{ color: '#666', marginBottom: 24, textAlign: 'center', maxWidth: 440 }}>
            Tente atualizar a página. Se o problema continuar, verifique sua conexão e tente
            novamente em alguns instantes.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: '12px 24px',
              fontSize: 16,
              backgroundColor: '#3b82f6',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
            }}
          >
            Atualizar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
